import { render } from "./DnsIcon.vue?vue&type=template&id=2c57a5f2"
import script from "./DnsIcon.vue?vue&type=script&lang=js"
export * from "./DnsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__